import { useMutation } from "@tanstack/react-query";

import { useLeftBarData } from "@/api/left-panel/hooks";
import { PromoCodeApi } from "@/api/man-profile/promo-code/PromoCode.api";
import {
  PromoCodeResponseDtoError,
  isPromoCodeSuccessResponse,
} from "@/api/man-profile/promo-code/models";
import { useOpenModal } from "@/components/modal/utils/openModal";
import { isAxiosExpectedError } from "@/utils/zod-utils";

export const useSendPromoCode = () => {
  const { openModal, removeAll, removeOne } = useOpenModal();
  const { refetch } = useLeftBarData();

  return useMutation(PromoCodeApi.sendPromoCode, {
    onSuccess: (data) => {
      let bonusesCount: number | string = "";

      if (isPromoCodeSuccessResponse(data)) {
        bonusesCount = data.requestDTO.dataMap.result || "";
      }

      openModal("INFORMATION_MODAL", {
        onOkClick: removeAll,
        message: `Congrats! You've received ${bonusesCount} bonus coins. Don't wait, use it now!`,
        statusReg: "success",
      });

      refetch();
    },

    onError: (error) => {
      let errorMessage = "Unexpected error";

      if (isAxiosExpectedError(error, PromoCodeResponseDtoError)) {
        errorMessage =
          error.response.data.requestDTO.dataMap.error || errorMessage;
      }

      openModal("INFORMATION_MODAL", {
        message: errorMessage,
        statusReg: "fail",
        onOkClick: removeOne,
      });
    },
  });
};
